// extracted by mini-css-extract-plugin
export default {"PZTransfersContainers":"SupplySummary_PZTransfersContainers__LobVv","supplyHeadings":"SupplySummary_supplyHeadings__jeu76","supplyValues":"SupplySummary_supplyValues__R0t7F"};